// Serbian 3-letter weekday abbreviations, Monday-first (`Date#getDay()`/moment's `.day()` are
// Sunday-first, hence the `+6) % 7` rotation everywhere this is indexed). Kept as a plain array
// instead of relying on moment's "sr" locale (registered as a side effect by bookingcard.js's
// `import "moment/locale/sr"`, which — being global — would silently reformat every other
// moment `.format('ddd')` call in the app too, and its own abbreviations/casing don't match this
// exactly) — this is the single source of truth PopUpCard.jsx and NewAppointmentFlow.jsx both
// read from, so a "Čet 10 · 10:00"-style label always looks the same everywhere it appears.
export const WEEKDAY_SHORT = ["Pon", "Uto", "Sre", "Čet", "Pet", "Sub", "Ned"];
